var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTomato(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2963",
    viewBox: "0 0 62.065 60.776",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-91.393 -435.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4703",
    transform: "matrix(.62752 -.024359 .014385 .65547 -9.7306 277.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4705",
    style: {
      fillRule: "evenodd",
      fill: "#9c151c"
    },
    d: "m206.82 249.85c1.23 3.52-0.46 12.33 0.84 14.48 1.38 2.28 18.95-1.21 29 5.86s21.75 26.02 13.93 42.5c-7.83 16.48-32.41 29.07-46.12 29.08-24.73-0.19-39.52-6.9-48.27-31.38-2.23-9.41-2.75-12.12-0.15-22.37 6.4-20.23 22.77-22.88 41.51-25.29 7.66-1.21-2.57-11.76 0.91-13.18 2.93-0.27 8.39-0.97 8.35 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4707",
    style: {
      fillRule: "evenodd",
      fill: "#e10119"
    },
    d: "m205.1 251c1.18 3.35-0.44 12.05 3.02 14.41 3.09 2.12 18.04-1.15 27.61 5.59 9.58 6.73 20.71 24.77 13.26 40.46-7.45 15.7-30.85 27.69-43.91 27.69-23.54-0.18-37.63-6.57-45.96-29.88-2.12-8.96-2.62-11.54-0.14-21.3 6.09-19.26 21.68-21.78 39.52-24.07 7.3-1.16-2.44-11.21 0.87-12.56 2.79-0.26 5.77-1.55 5.73-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4709",
    style: {
      opacity: 0.34733,
      fill: "#9c151c"
    },
    d: "m190.14 267.6c-17.38 2.18-29.73 19.25-27.61 38.08s17.92 32.33 35.29 30.15c0.39 1.98-20.65-15.41-24.13-31.34-1.92-17.05 4.05-32.65 18.84-37.07-0.79 0.03-1.6 0.08-2.39 0.18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4711",
    style: {
      opacity: 0.34733,
      fill: "#fcaf3e"
    },
    d: "m219.38 271.37c-2.23 0-4.39 0.27-6.47 0.75 7.64 6.12 12.81 17.84 12.81 31.25 0 7.64-1.68 14.69-4.53 20.5 14.36-0.89 25.75-12.29 25.75-26.22 0-14.5-12.36-26.28-27.56-26.28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4713",
    style: {
      fillRule: "evenodd",
      fill: "#639f1b"
    },
    d: "m199.98 251.48c-0.18 1.31 1.34 6.97 1.58 9.21 0.23 2.23 0.83 3.1-1.53 3.49-2.36 0.4-4.22 0.8-6.36 0.8-2.13 0-4.16-0.33-5.3 1.28-1.14 1.62-2.39 2.9-3.31 4.44-0.92 1.55 1.39 0.55 3.1 0.42 1.72-0.14 6.25-2.91 7.35-1.23 1.09 1.68-2.11 10.92-0.79 11.31 1.31 0.4 5.96-8.85 8.68-8.94s6.18 8.29 7.63 8.42c1.44 0.13 0-7.37 1.05-7.63s4.47 6.14 5.26 6.05-0.74-6-0.53-6.58c0.22-0.57 3.37 1.09 1.89-0.46-1.48-1.56-1.22-3.85-4-4.49-2.77-0.65-6.97-0.81-8.77-3.36-1.79-2.55-0.72-10.29-1.47-12.62-0.74-0.43-3.9-0.48-4.48-0.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4715",
    style: {
      opacity: 0.50763,
      fillRule: "evenodd",
      fill: "#8ae234"
    },
    d: "m199.44 266.32c2.19 1.29-2.48-4.49-8.86 0-6.46 4.53-3.33 6.3-2.85 4.11 0.41-1.88 9.65-5.32 11.71-4.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4718",
    style: {
      opacity: 0.50763,
      fillRule: "evenodd",
      fill: "#8ae234"
    },
    d: "m204.52 267.41c-2.15 1.34 2.34-2.92 8.84 1.4 8.97 9.01-5.91-1.99-8.84-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4720",
    style: {
      fillRule: "evenodd",
      fill: "#77c127"
    },
    d: "m201.02 266l-3.48 4.12-1.27 8.23 4.75-12.35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4722",
    style: {
      fillRule: "evenodd",
      fill: "#77c127"
    },
    d: "m202.06 266.74l4.59 2.82 3.78 7.42-8.37-10.24z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTomato);
export default __webpack_public_path__ + "static/media/tomato.409279ec.svg";
export { ForwardRef as ReactComponent };